import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, HeartIcon, UserIcon } from "@heroicons/react/20/solid";
import tienda from '../assets/tienda/logotienda.png';

const Tienda = () => {
  return (
      <section id="tienda" className="mx-auto xl:bg-tienda bg-no-repeat bg-blue-950 bg-cover w-full py-32">
        <div className="flex flex-col items-center max-w-5xl px-6 lg:px-8 text-right">
          <img
            alt="Tienda"
            src={tienda}
            className="object-contain w-full h-72 px-2"
          />
          <p className="text-md text-white mb-10">
            Nuestra tienda de insumos de buceo ofrece todo lo necesario para disfrutar cada inmersión con seguridad y confianza. Trabajamos con productos de alta calidad y marcas confiables, pensados para acompañar tanto a buzos recreativos como profesionales. Bucea tranquilo, nosotros nos encargamos de tu equipamiento.
          </p>
          {/* <div className="mx-auto px-4 flex flex-col sm:flex-row justify-around flex-wrap lg:flex-nowrap gap-8 items-center mt-10">
            <div className="flex flex-row md:flex-row items-center justify-center flex-wrap lg:flex-nowrap gap-2">
                <div className='flex flex-col items-center '>
                    <MapPinIcon className="h-20 w-20 text-white" />
                    <p className='text-2xl text-white'>Envíos a todo Chile</p>
                    <p>Ubicados en Puerto Montt, despachos a todo el país</p>
                </div>
                <div className='flex flex-col items-center '>
                    <HeartIcon className="h-20 w-20 text-white" />
                    <p className='text-2xl text-white'>Hecho con cuidado</p>
                    <p>Creemos en hacer las cosas mejor</p>
                </div>
                <div className='flex flex-col items-center '>
                    <UserIcon className="h-20 w-20 text-white" />
                    <p className='text-2xl text-white'>Un equipo con un objetivo</p>
                    <p>Personas reales creando grandes productos</p>
                </div>
            </div>
          </div> */}
          <Link to="http://www.frogmantienda.cl" className="uppercase text-white tracking-widest hover:text-accent transition-all">
                <button className='border-solid border-white border-2 rounded-full hover:bg-blue-950 uppercase transition-all font-bold mt-10'><p className='mx-2 my-1 text-3xl'>CONOCE NUESTRA TIENDA</p></button>
          </Link>
          <div className="mx-auto px-4 flex flex-col sm:flex-row justify-around flex-wrap lg:flex-nowrap gap-8 items-center mt-10">
            <div className="max-w-md flex flex-row md:flex-row items-center justify-center flex-wrap lg:flex-nowrap gap-2">
              {/* <img
                alt="Australis Seafoods"
                src={australis}
                className="object-contain w-full h-20 px-2"
              />
              <img
                alt="Yadran High Quality Salmon"
                src={yadran}
                className="object-contain w-full h-20 px-2"
              />
              <img
                alt="Camanchaca"
                src={camanchaca}
                className="object-contain w-full h-20 px-2"
              />
              <img
                alt="Novofish"
                src={novofish}
                className="object-contain w-full h-20 px-2"
              /> */}
            </div>          
          </div>
        </div>
      </section>
    );
};

export default Tienda;